import { render, staticRenderFns } from "./CreateCampaignReviewCardAdvancedOptions.vue?vue&type=template&id=065bff18&scoped=true"
import script from "./CreateCampaignReviewCardAdvancedOptions.vue?vue&type=script&lang=js"
export * from "./CreateCampaignReviewCardAdvancedOptions.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignReviewCardAdvancedOptions.vue?vue&type=style&index=0&id=065bff18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065bff18",
  null
  
)

export default component.exports